import './App.scss';
import { FullScreen, useFullScreenHandle } from 'react-full-screen';
import { CurrentTimeProvider } from './context/TimeContext/CurrentTimeContextProvider';
import { Navigate, Route, Routes } from 'react-router-dom';
import { CommonContextProvider } from './context/CommonContextProvider/CommonContextProvider';
import OneBoardRoutes from './Routes/OneBoardRoutes';

function App() {
  const screenHandle = useFullScreenHandle();

  return (
    <FullScreen handle={screenHandle} className="App">
      <CommonContextProvider data={{ screenHandle }}>
        <CurrentTimeProvider>
          <Routes>
            <Route path="place/*" element={<OneBoardRoutes />} />
            <Route path="*" element={<Navigate to="place" />} />
          </Routes>
        </CurrentTimeProvider>
      </CommonContextProvider>
    </FullScreen>
  );
}

export default App;
